import createVueComponent from '../createVueComponent';

const MinusSquare = createVueComponent('MinusSquareIcon', [
  [
    'rect',
    { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'afitv7' },
  ],
  ['path', { d: 'M8 12h8', key: '1wcyev' }],
]);

export default MinusSquare;
